export const GET_SERVICE_NAMES = 'GET_SERVICE_NAMES';
export const GET_SERVICE_NAME_BY_ID = 'GET_SERVICE_NAME_BY_ID';
export const UPDATE_SERVICE_NAME = 'UPDATE_SERVICE_NAME';
export const DELETE_SERVICE_NAME = 'DELETE_SERVICE_NAME';
export const CREATE_SERVICE_NAME = 'CREATE_SERVICE_NAME';
